(function () {
    const $ = require('jquery');

    $('.accordion-container button').on('click', function() {
        $(this).closest('.accordion-container').find('.contents').toggle();
        $(this).find('.icon').toggleClass('is-open');
    });

    const $scrollForMore = $('#scroll-for-more-wrapper');

    if (window.scrollY > 20) {
        $scrollForMore.hide();
    }

    $(window).on('scroll', function() {
        if ($(window).scrollTop() < 20) {
            $scrollForMore.fadeIn();
        } else {
            $scrollForMore.fadeOut();
        }
    });
})();
